import axios from 'axios';
import getToken from './getToken.js';

const GetAllResumes = async () => {
  const token = getToken();
  const url = process.env.REACT_APP_BACKEND_ALLRESUMES_URL;
  const response = await axios.get(url, {
    headers: {
      'Content-Type': 'application/json',
      token: token,
    },
  });
  return response.data;
};

export default GetAllResumes;
